/** What each plan includes, in the words the plan cards use. */

export const FREE_LIMIT = 25;

export function freePlanPoints(limit: number = FREE_LIMIT): string[] {
  return [
    `Your ${limit} most recent recordings stay playable`,
    'Share links, comments and reactions',
    'The Mac recorder and the browser recorder',
  ];
}

export const TEAM_PLAN_POINTS = [
  'Unlimited recordings, nothing locks',
  'Captions and searchable transcripts',
  'Cut, trim and correct your recordings',
  'One shared library the whole team records into',
  'Admins who can see and manage every recording',
];

/**
 * The paid features a free account is shown anyway. Every one of them is on
 * the page, looking like itself, and leads here: the Subscription tab, which
 * is the purchase page, told which feature brought the person so it can say
 * so at the top. Hiding the controls taught nobody what Team is for.
 */
export type PaywallFeature = 'editing' | 'transcripts' | 'uploads';

export const PAYWALL_PITCH: Record<PaywallFeature, string> = {
  editing: 'Cutting, trimming and correcting recordings comes with Team.',
  transcripts: 'Captions and a searchable transcript come with Team.',
  uploads: 'Turning a video you already have into a Slate recording comes with Team.',
};

export function paywallPath(feature: PaywallFeature): string {
  return `/settings/subscription?feature=${feature}`;
}

export function paywallFeatureFromSearch(search: string): PaywallFeature | null {
  const value = new URLSearchParams(search).get('feature');
  return value !== null && value in PAYWALL_PITCH ? (value as PaywallFeature) : null;
}
